<template>
  <div class="page-content">
    <div class="page-banner program_banner">
      <div class="page-banner-content">
        <p><span class="pc-browser">VALSE&nbsp;&nbsp;2025&nbsp;&nbsp;</span>AGENDA</p>
      </div>
    </div>
    <div class="main-container">
      <div class="content-item-grp">
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">VALSE 2022会议总体日程</span>
          </div>
          <div class="item-content">
            <div class="item-content-info">
              <p><span class="text-black-border"> 会议时间：</span>2022年10月8日-10日</p>
              <p><span class="text-black-border"> 会议地点：</span>天津国际博览中心3C展厅 (萧山区钱江世纪城奔竞大道353号)</p>
              <!-- <p><span class="text-black-border"> 会议现场注册时间安排:</span></p>
                <div class="text-indent-two">4月11日：12:00-18:00</div>
                <div class="text-indent-two">4月12日：08:00-18:00</div>
                <div class="text-indent-two">4月13日：08:00-18:00</div> -->
            </div>
            
            
            
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <p>© VALSE 2026 All rights reserved</p>
      <!--<img src="../../static/images/other-footer-bg.png"/>-->
    </div>
  </div>
</template>

<script>
    export default {
        name: "Programimage",

    }
</script>

<style scoped>
  .program_banner{
    background-image: url("../../static/images/program_banner-20.jpg");
  }
  .program_banner p{
    /*color: white;*/
  }
  .footer{
    /* position: fixed; */
    bottom: 0;
  }
  .font-bolder{
    font-weight: bolder;
  }
  .agenda-item{
    text-align: left;
    padding: 4px;
  }
  .agenda-item:hover{
    cursor: pointer;
    color: #f27d00;
  }
  .item-title-label{
    font-size: 12px;
    color: #2c3e50;
    padding-top: -10px;
  }
  .report-text{
    font-weight: bold;
  }
  .pro-tutorial-item-info{
    padding:8px 16px;
  }
  .pro-workshop-detail{
    margin-left: 16px;
    padding: 4px;
  }
  .pro-workshop-title{
    margin-bottom: 8px;
  }
  .item-content-title{
    font-weight: bolder;
    font-size: 18px;
    margin-bottom: 8px;
    margin-top: 16px;
  }
  .item-content-info{
    text-align: left;
  }
  .text-indent-two{
    text-indent: 2em;
  }
  .text-black-border{
    font-weight: bold;
  }
  .time-td{
    width: 100px;
    min-width: 100px;
    max-width: 100px;
  }
  .table-gaoliang{
    color: #409EFF;
  }
  .didian-td{
    width: 80px;
    min-width: 80px;
    max-width: 80px;
  }
  .zhuchiren{
    min-width: 100px;
  }
  .program-table{
    width: 100%;
    margin: 4px 0;
    border-top: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
  }
  .program-table td,.program-table th{
    border-right: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
  }
  .program-table th{
    height: 40px;
  }
  .program-table td{
    padding: 8px 4px;
    font-size: 14px;
  }
  .font-weight{
    font-weight: bold;
  }
  .td-title{
    padding: 4px;
    color: #409EFF;
    font-weight: bold;
  }
  .td-content{
    text-align: left;
  }
  .fenge-td{
    background-color: #DCDFE6;
    height: 4px;
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/Programimage.vue